import {Injectable} from '@angular/core';
import {EntityStoreService} from '../modules/akita-mimic/services/entity-store.service';
import {VaultState} from '../modules/akita-mimic/models/store-states/vault-state.model';
import {Vault} from '../api/models/vault';


@Injectable({ providedIn: 'root' })
export class VaultStore extends EntityStoreService<VaultState, Vault> {
    public constructor() {
        super('vault', {
            entities: {},
            ids: [],
            active: [],
            loading: false,
            userVaults: [],
            hasDataLoaded: false,
            selected: '',
            vaultIdInParams: undefined,
            tagGroupDefinitions: {}
        });
    }
}
